import { render, staticRenderFns } from "./kmodal.vue?vue&type=template&id=0c75b6a1&scoped=true"
import script from "./kmodal.vue?vue&type=script&lang=js"
export * from "./kmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75b6a1",
  null
  
)

export default component.exports